import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'
import { FlexTable } from 'src/components/shared/flexTables'
// import { mockSelectedOffers } from 'src/components/selected-offers-list/mock'
// import { selectedOffersSchema } from 'src/components/selected-offers-list/selectedOffersSchema'

const state = {
  [NameSpace.STATE_SELECTED_PENDING_APPROVALS]: {
    headers: [],
    data: [],
    error: null
  },
  [NameSpace.OFFERS]: {
    data: null
  }
}

const getters = {
  [NameSpace.GET_SELECTED_PENDING_APPROVALS]: state => {
    return state[NameSpace.STATE_SELECTED_PENDING_APPROVALS]
  },
  [NameSpace.GET_OFFERS]: state => {
    return state[NameSpace.OFFERS]
  }
}

const mutations = {
  [NameSpace.MUTATE_SELECTED_PENDING_APPROVALS]: (state, payload) => {
    state[NameSpace.STATE_SELECTED_PENDING_APPROVALS] = payload
  },
  [NameSpace.MUTATE_OFFERS]: (state, payload) => {
    state[NameSpace.OFFERS] = payload
  }
}

const actions = {
  [NameSpace.ACTION_SELECTED_PENDING_APPROVALS]: ({ commit }, payload) => {
    ParseService.getHighLevelOffers(payload)
      .then(offersData => {
        let tableInstance = new FlexTable(offersData.header, offersData.data, 1)
        let tableHeaders = tableInstance.getObjectTableHeaders(offersData.header, 'Offer Id', 'lock', 'my_offer')
        let tableHeadersString = tableInstance.getStringTableHeaders(offersData.header)
        let tableData = tableInstance.getCellDataAsObject(tableHeadersString, offersData.data, 'makeLink', 'selected_offer_list', 1)
        commit(NameSpace.MUTATE_SELECTED_PENDING_APPROVALS, {
          headers: tableHeaders,
          data: tableData,
          error: null
        })
        commit(NameSpace.MUTATE_OFFERS, {
          data: tableData
        })
      })
      .catch(err => {
        commit(NameSpace.MUTATE_SELECTED_PENDING_APPROVALS, {
          headers: [],
          data: [],
          error: err
        })
        commit(NameSpace.MUTATE_OFFERS, {
          data: null
        })
      })
  },
  [NameSpace.RESET_SELECTED_PENDING_APPROVALS]: ({ commit }, payload) => {
    commit(NameSpace.MUTATE_SELECTED_PENDING_APPROVALS, {
      headers: [],
      data: [],
      error: null
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/selectedOfferList.js